<template>
    <div class="warning-history">
        <el-row class="description">
            <el-col>
                <div class="breadcrumb">
                    <div class="now">AI Alerts</div>
                </div>

                <el-input class="warningInput" v-model="queryInfo.keywords" placeholder="Please enter keywords to search"
                    suffix-icon="el-icon-search" clearable></el-input>

                <span class="state">Alert Level：</span>
                <el-select class="stateSelect" v-model="queryInfo.level" placeholder="Please select" clearable>
                    <el-option v-for="item in levellist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">Alert Type：</span>
                <el-select class="stateSelect" v-model="queryInfo.type" placeholder="Please select" clearable>
                    <el-option v-for="item in typelist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">Associated System：</span>
                <el-select class="stateSelect" v-model="queryInfo.module" placeholder="Please select" clearable>
                    <el-option v-for="item in modulelist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">Current Status：</span>
                <el-select class="stateSelect" v-model="queryInfo.status" placeholder="Please select" clearable>
                    <el-option v-for="item in selectOption1" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="serchAllRuleData()" class="searchButton" round>Search</el-button>
                <el-button @click="resetSearch()" class="resetButton" round>Reset</el-button>
                <br />
                <div class="btn_box">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        <div class="check_box">
                            <el-checkbox v-model="checked" @change="clickcheck()">Select All</el-checkbox>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <div v-for="item in iconlist" class="iconbox" :style="'color:' + item.color" :key="item.id"
                                @click="openmylog(item.id)">
                                <img :src="item.img" alt="">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="center">
            <el-table ref="usertable" :data="warninglist" style="width: 100%">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="id" label="Alert ID" width="100" align="center"></el-table-column>
                <el-table-column prop="name" label="Alert Name" align="center"></el-table-column>
                <el-table-column prop="level_name" label="Alert Level" align="center"></el-table-column>
                <el-table-column prop="type_name" label="Alert Type" align="center"></el-table-column>
                <el-table-column prop="module_name" label="Associated System" align="center" min-width="150"></el-table-column>
                <el-table-column prop="created_at" label="Creation Time" align="center"></el-table-column>
                <el-table-column prop="noti_type" label="Alert Channel" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.noti_type_name }}
                    </template>
                </el-table-column>
                <el-table-column prop="handle_reason" label="Reason" align="center"></el-table-column>
                <el-table-column prop="handle_action" label="Operator Action" align="center"></el-table-column>
                <el-table-column prop="handler" label="Handled By" align="center"></el-table-column>
                <el-table-column prop="handle_at" label="Resolution Time" align="center"></el-table-column>
                <el-table-column prop="status_des" label="Current Status" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="lookon">{{
                            scope.row.status_des
                            }}</span>
                        <span v-if="scope.row.status == 0" class="lookoff">{{
                            scope.row.status_des }}</span>
                        <span v-if="scope.row.status == 2" class="closeon">{{
                            scope.row.status_des }}</span>
                        <span v-if="scope.row.status == 3" class="overlook">{{
                            scope.row.status_des }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Action" align="center" width="500">
                    <template slot-scope="scope">
                        <span class="lookDetail" @click="startdeal(scope.row)" style="color: rgba(36, 102, 168, 1);"
                            v-if="scope.row.status == 0">
                            <img src="../../../assets/停止 (1).png" alt="">开始处理
                        </span>
                        <span class="lookDetail" @click="lookDetail(scope.row, 'deal')"
                            style="color: rgba(76, 194, 164, 1);" v-if="scope.row.status == 0 || scope.row.status == 1">
                            <img src="../../../assets/编辑.png" alt="">去处理
                        </span>
                        <span class="lookDetail" @click="lookDetail(scope.row, 'delete')"
                            v-if="scope.row.status == 0 || scope.row.status == 1"
                            style="color:rgba(184, 75, 75, 1);"><img src="../../../assets/删除.png" alt="">忽略</span>
                        <span class="lookDetail" @click="gotodetail(scope.row.id, scope.row.index)"
                            style="color:rgba(36, 102, 168, 1);">
                            <img src="../../../assets/查看.png" alt="">View Details
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40]" :page-size="100" layout="->,total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <dealdialog :title="dialogtitle" :infoid="infoid" :dealdialogVisible="dealdialogVisible"
            @closedrawer="closedrawer" v-if="dealdialogVisible">
        </dealdialog>
        <el-dialog :title="logtitle" :visible.sync="logVisible" width="30%" :before-close="Closelog" v-if="logVisible">
            <div v-if="logtitle == '停用提示'" class="stop_text">
                停用该类型后，关联的规则都会禁用，是否确认停用该条类型？
            </div>
            <div v-else class="delete_text">
                信息删除后，关联的规则都会禁用，该类型信息无法被恢复，是否仍要删除这条信息？
            </div>
            <div class="prj_footer" slot="footer">
                <div class="prj_content">
                    <div class="about">
                        <!-- <span>查看关联的规则</span> -->
                    </div>
                    <div>
                        <el-button @click="logVisible = false">取消</el-button>
                        <el-button type="warning" round @click="handleCommand(mycommand)"
                            v-if="logtitle == '停用提示' && mycommand">确认停用</el-button>
                        <el-button type="danger" round @click="handleCommand(mycommand)"
                            v-if="logtitle == '删除提示' && mycommand">确认删除</el-button>
                        <el-button type="warning" round @click="changetype(myrow)"
                            v-if="logtitle == '停用提示' && myrow">确认停用</el-button>
                        <el-button type="danger" round @click="deleterule(myrow)"
                            v-if="logtitle == '删除提示' && myrow">确认删除</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import config from '@/utils/config';
import dealdialog from '../component/dealdialog.vue'

export default {
    components: {
        dealdialog
    },
    data() {
        return {
            dealdialogVisible: false,
            warninglist: null,
            form: {
                name: '',
                des: ''
            },
            dialogtitle: null,
            alertAllData: null,
            iconlist: [],
            selectOption1: [
                { id: "-1", name: "All" },
                { id: "0", name: "待处理" },
                { id: "1", name: "处理中" },
                { id: "2", name: "已完成" },
                { id: "3", name: "已忽略" },
            ],
            selectOption2: [],
            modulesOption: [],
            queryInfo: {
                module: '-1',
                level: '-1',
                type: '-1',
                keywords: "",
                status: '-1',
                pagenum: 1,
                pagesize: 10,
            },
            total: 0,
            states: "",
            modules: "",
            dialogVisible: false,
            changeDialogVisible: false,
            changedata: {},
            serchnum: 0,
            type: 0,
            logVisible: false,
            myrow: null,
            checked: null,
            mycommand: null,
            logtitle: null,
            levellist: null,
            typelist: null,
            modulelist: null
        };
    },
    created() {
        this.getAlllevel()
        this.getAlltype()
        this.getmodulelist()
        this.getall();
    },
    watch: {
        "$route.query.id": {
            handler(val) {
                this.dealdialogVisible = false;
                if (val) {
                    this.infoid = val * 1;
                    this.dialogtitle = '处理原因说明';
                    this.type = 1;
                    this.dealdialogVisible = true;
                }
            },
            immediate: true,
        }
    },
    methods: {
        //获取告警规则依赖列表
        async getmodulelist() {
            // this.checked = false
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/algpub/module/info", {
                mode: -1
            });
            if (res.code == 200) {
                this.modulelist = res.data
                this.modulelist.push(
                    {
                        id: "-1", name: "All"
                    }
                )
            }
        },
        //获取等级列表
        async getAlllevel() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/level/used/all?mode=1");
            console.log(res.data);
            this.levellist = res.data
            this.levellist.push(
                {
                    id: "-1", name: "All"
                }
            )
        },
        //获取类型列表
        async getAlltype() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/type/used/all?mode=1");
            console.log(res.data);
            this.typelist = res.data
            this.typelist.push(
                {
                    id: "-1", name: "All"
                }
            )
        },
        //获取告警规则列表
        async getall() {
            this.checked = false
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/record/list", {
                params: this.queryInfo,
            });
            if (res.code == 200) {
                this.warninglist = res.data.data;
                this.total = res.data.total_count;
            }
        },
        //重置查询数据
        resetSearch() {
            this.queryInfo.pagenum = 1;
            this.queryInfo.status = '-1';
            this.queryInfo.keywords = "";
            this.queryInfo.module = '-1';
            this.queryInfo.level = '-1';
            this.queryInfo.type = '-1';
            this.serchnum = 0;
            this.getall();
        },
        //查看告警规则详情
        async lookDetail(row, type) {
            this.infoid = row.id
            if (type == 'deal') {
                this.dialogtitle = '处理原因说明';
                this.type = 1;
                this.dealdialogVisible = true;
            } else {
                this.dialogtitle = '忽略原因说明';
                this.type = 1;
                this.dealdialogVisible = true;
            }
        },
        filterHandler(value, row, column) {
            const property = column["property"];
            return row[property] === value;
        },
        //删除告警规则
        async deleterule(row) {
            let idlist = [];
            idlist.push(row.id);
            console.log(idlist);
            const { data: res } = await this.$http.delete(config.httpPrefix + "/alarm/record/delete", {
                data: {
                    ids: idlist,
                }
            }
            );
            if (res.code == 200) {
                this.Closelog();
                return this.$message.success("删除当前告警等级成功");
            } else {
                return this.$message.error(res.msg);
            }
        },
        openlog(row, type) {
            if (type == 'edit') {
                this.logtitle = '停用提示'
            } else {
                this.logtitle = '删除提示'
            }
            this.logVisible = true
            this.myrow = row
        },
        //修改告警状态
        async changetype(row) {
            let idlist = [];
            idlist.push(row.id);
            if (row.status == 1) {
                console.log(row);
                const { data: res } = await this.$http.put(config.httpPrefix + "/alarm/record/status/update", {
                    ids: idlist,
                    status: 0,
                });
                if (res.code == 200) {
                    this.logVisible = false
                    this.getall();
                    return this.$message.success("修改告警规则启停状态成功");

                } else {
                    return this.$message.error("修改告警规则启停状态失败");
                }
            } else {
                console.log("启用");
                const { data: res } = await this.$http.put(config.httpPrefix + "/alarm/record/status/update", {
                    ids: idlist,
                    status: 1,
                });
                if (res.code == 200) {
                    this.getall();
                    return this.$message.success("修改告警规则启停状态成功");
                } else {
                    return this.$message.error("修改告警规则启停状态失败");
                }
            }
        },
        openmylog(command) {
            if (command == 'b') {
                this.logVisible = true
                this.mycommand = command
                this.logtitle = '停用提示'
            } else if (command == 'c') {
                this.logVisible = true
                this.mycommand = command
                this.logtitle = '删除提示'
            } else {
                this.handleCommand(command)
            }
        },
        //批量启用告警规则
        async handleCommand(command) {
            console.log(command);

            const usertablechose = this.$refs.usertable.selection;
            if (usertablechose.length === 0) {
                return this.$message.error("没有选中任何警告规则");

            }
            let switchelist = [];
            for (var a = 0; a < usertablechose.length; a++) {
                console.log(usertablechose[a]);
                switchelist[a] = usertablechose[a].id;
            }
            if (command == "a") {
                const { data: res } = await this.$http.put(config.httpPrefix + "/alarm/record/status/update", {
                    ids: switchelist,
                    status: 1,
                });
                if (res.code == 200) {

                    this.Closelog()
                    this.checked = null

                    return this.$message.success("批量修改告警规则启停状态成功");
                } else {
                    return this.$message.error("批量修改告警规则启停状态失败");
                }
            } else if (command == "b") {
                const { data: res } = await this.$http.put(config.httpPrefix + "/alarm/record/status/update", {
                    ids: switchelist,
                    status: 0,
                });
                if (res.code == 200) {
                    this.Closelog()
                    this.checked = null
                    return this.$message.success("批量修改告警规则启停状态成功");
                } else {
                    return this.$message.error("批量修改告警规则启停状态失败");
                }
            } else {
                const { data: res } = await this.$http.delete(config.httpPrefix + "/alarm/record/delete", {
                    data: {
                        ids: switchelist,
                    }
                });
                if (res.code == 200) {
                    this.Closelog()
                    this.checked = null
                    return this.$message.success("批量删除告警规则成功");
                } else {
                    return this.$message.error("批量删除告警规则失败");
                }
            }
        },
        handleClose() {
            this.getall();
            this.dialogVisible = false
        },
        Closelog() {
            this.myrow = null;
            this.mycommand = null;
            this.getall();
            this.logVisible = false
        },
        //新增等级
        async commit() {
            if (this.type == 1) {
                const { data: res } = await this.$http.put(
                    config.httpPrefix + "/alarm/record/info/update?id=" + this.form.id,
                    this.form
                );
                if (res.code == 200) {
                    this.handleClose()
                    return this.$message.success("修改告警等级成功");
                } else {
                    return this.$message.error(res.msg);
                }
            } else {
                const { data: res } = await this.$http.post(
                    config.httpPrefix + "/alarm/record/create",
                    this.form
                );
                if (res.code == 200) {
                    this.handleClose()
                    return this.$message.success("添加告警等级成功");
                } else {
                    return this.$message.error(res.msg);
                }
            }
        },
        serchAllRuleData() {
            this.getall();
        },
        handleSizeChange(val) {
            this.queryInfo.pagesize = val
            this.getall();

        },
        handleCurrentChange(val) {
            this.queryInfo.pagenum = val
            this.getall();
        },
        clickcheck() {
            console.log(this.checked);
            if (this.checked) {
                this.toggleSelection(this.warninglist)
            } else {
                this.toggleSelection()
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.usertable.toggleRowSelection(row);
                });
            } else {
                this.$refs.usertable.clearSelection();
            }
        },
        closedrawer() {
            this.dealdialogVisible = false;
            if (this.$route.query.id) {
                this.$router.push("/warningCenter");
            }
            this.getall();
        },
        gotodetail(detailId, index) {
            this.$router.push({
                path: "/alertDetail",
                query: { id: detailId, index: index },
            });
        },
        startdeal(item) {
            let ids = []
            ids.push(item.id)
            this.$confirm('是否开始处理该告警?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.put(
                    config.httpPrefix + "/alarm/record/deal/start?id=", {
                    ids: ids,
                });
                if (res.code == 200) {
                    this.getall()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.warning-history {
    .breadcrumb {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18.75px;
        color: rgba(77, 74, 74, 1);

        .path {
            font-size: 14px;
            margin-left: 6px;
            margin-right: 6px;
        }

        .now {
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0px;
            line-height: 18.75px;
            color: rgba(36, 102, 168, 1);
            text-align: left;
            vertical-align: top;
        }
    }

    .description {
        margin: 25px;
        margin-top: 0px;
        padding-top: 36px;

        .el-input {
            width: 25%;
        }

        .addButton {
            margin-left: 0 !important;
        }
    }

    h2 {
        margin-top: 0px;
        margin-bottom: 30px;
    }

    .center {
        margin: 25px;
        height: 800px;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .el-input {
        display: inline-block !important;
        width: 25%;
    }

    .check_box {
        margin-right: 30px;

        ::v-deep .el-checkbox.is-checked {
            .el-checkbox__label {
                color: rgba(36, 102, 168, 1);
            }
        }
    }

    .iconbox {
        margin-right: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            height: 21px;
            margin-right: 6px;
        }
    }

    .state {
        margin-left: 40px;
        color: #878787;
    }

    .warningInput {
        width: 20%;
    }

    .stateSelect {
        width: 8%;
    }

    .btn_box {
        margin-top: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .searchButton {
        background-color: rgba(36, 102, 168, 1);
        border-color: rgba(36, 102, 168, 1);
        margin-left: 50px !important;
    }

    .resetButton {
        margin-left: 30px !important;
    }

    ::v-deep .el-table th.is-leaf {
        height: 60px;
        font-size: 15px;
        background: rgba(36, 102, 168, 0.1);
        color: #878787;
        border: none;
    }

    ::v-deep .el-table__body {
        //-webkit-border-horizontal-spacing: 13px;  // 水平间距
        -webkit-border-vertical-spacing: 20px; // 垂直间距
    }

    ::v-deep .el-table,
    .el-table__expanded-cell {
        background-color: transparent
    }

    ::v-deep .el-table::before {
        height: 0;
    }

    .el-pagination {
        margin-top: 40px;
        margin-left: 20px;
        margin-bottom: 20px;
    }

    .stop_text {
        color: rgba(255, 141, 26, 1);
    }

    .delete_text {
        color: rgba(184, 75, 75, 1);
    }

    .lookon {
        display: inline-block;
        color: rgba(36, 102, 168, 1);
        width: 88px;
        height: 36px;
        line-height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgba(36, 102, 168, 0.1);
    }

    .lookoff {
        display: inline-block;
        color: rgba(103, 103, 103, 1);
        width: 88px;
        line-height: 36px;
        height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgba(230, 231, 236, 1);
    }

    .closeon {
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        width: 88px;
        line-height: 36px;
        height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgb(76, 194, 164);
    }

    .overlook {
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        width: 88px;
        line-height: 36px;
        height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgb(255, 141, 26);
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid rgba(219, 219, 219, 1);
    }

    ::v-deep .el-dialog {
        opacity: 1;
        border-radius: 10px;
        background: rgba(255, 255, 255, 1);
    }

    .prj_content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .about {
            color: rgba(36, 102, 168, 1);
        }
    }

    ::v-deep .el-table td.el-table__cell div {

        display: flex;
        justify-content: center; //水平
        align-items: center; //垂直
    }


    .lookDetail {
        cursor: pointer;
        margin-right: 30px;
        line-height: 26px;
        display: flex;
        justify-content: center; //水平
        align-items: center; //垂直

        img {
            height: 16px;
            margin-right: 6px;
        }
    }

    .page {
        padding-bottom: 10px;
        margin-right: 25px;
    }

    ::v-deep .el-pagination { 
        .el-pagination__rightwrapper {
            display: flex;
            align-items: center;
        }
    }

    ::v-deep .el-pager li {
        width: 40px;
        height: 40px;
        opacity: 1;
        margin-left: 16px;
        margin-right: 16px;
        line-height: 40px;
        border-radius: 50%;
        color: rgba(103, 103, 103, 1);
        background: #E6E7EC;
    }

    ::v-deep .el-pager li.active {
        color: rgba(255, 255, 255, 1);
        background-color: rgba(36, 102, 168, 1);
        cursor: default;
    }

    ::v-deep .el-pagination .btn-prev {
        width: 40px;
        height: 40px;
        opacity: 1;
        border-radius: 50%;
        background: rgba(244, 246, 251, 1);
        border: 1px solid rgba(230, 231, 236, 1);
    }

    ::v-deep.el-pagination .btn-next {
        width: 40px;
        height: 40px;
        opacity: 1;
        border-radius: 50%;
        background: rgba(244, 246, 251, 1);
        border: 1px solid rgba(230, 231, 236, 1);
    }

    ::v-deep .el-pagination__jump {
        display: flex !important;
        align-items: center;
        font-size: 16px !important;

        .el-input {
            display: flex;
            align-items: center;
            width: 100px;

        }
    }

    ::v-deep .el-pagination__total {
        font-size: 16px !important;
        vertical-align: middle !important;
    }

    ::v-deep .el-pagination__sizes {
        display: flex !important;
        align-items: center;
        font-size: 16px !important;
        line-height: 40px !important;
        font-size: 16px !important;
        vertical-align: middle !important;
    }

    ::v-deep .el-input__inner {
        border-radius: 20px;
    }

    ::v-deep .el-textarea {
        width: 97%;
    }
}
</style>
